import { useState, useRef, useCallback, useEffect } from 'react';

export function useDraggable(resetOn?: boolean) {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const dragging = useRef(false);
  const startPos = useRef({ x: 0, y: 0 });
  const startMouse = useRef({ x: 0, y: 0 });

  useEffect(() => {
    setPosition({ x: 0, y: 0 });
  }, [resetOn]);

  const onMouseDown = useCallback((e: React.MouseEvent) => {
    if (e.button !== 0) return;
    if ((e.target as HTMLElement).closest('button, input, select, textarea, a, label')) return;

    dragging.current = true;
    startPos.current = { x: position.x, y: position.y };
    startMouse.current = { x: e.clientX, y: e.clientY };

    const onMouseMove = (ev: MouseEvent) => {
      if (!dragging.current) return;
      setPosition({
        x: startPos.current.x + ev.clientX - startMouse.current.x,
        y: startPos.current.y + ev.clientY - startMouse.current.y,
      });
    };

    const onMouseUp = () => {
      dragging.current = false;
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
    };

    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
    e.preventDefault();
  }, [position]);

  const dragStyle = {
    transform: `translate(${position.x}px, ${position.y}px)`,
  };

  const dragHandleProps = {
    onMouseDown,
    style: { cursor: 'move' } as React.CSSProperties,
  };

  return { dragStyle, dragHandleProps };
}
